import routes from './router'
import Router from 'vue-router'
import {post} from './api/index'
import store from './store'
import {formatRoutes,loadView} from './utils/index'
const createRouter = () => new Router({
  routes,
})
const router = createRouter();

router.beforeEach(async(to, from, next) => {
  // if(to.path == '/'){
  //   next({
  //     path: '/index'
  //   })
  // }
  if(to.meta&&to.meta.animation){
    store.dispatch('setEntryUrl',to.path);
    setTimeout(() => {
      window.scrollTo(0,0)
      next();
    }, 2*1000);
  }else{
    window.scrollTo(0,0)
    next();
  }

  // console.log(to)

  // if{
  //   let token = sessionStorage.getItem('token')||'1';
  //   var white_list = ['/template','/login','/agreement'];
  //   // console.log(white_list.indexOf(to.path))
  //   if (!token && white_list.indexOf(to.path) == -1) {
  //     next({
  //       path: '/login'
  //     })
  //   } else if(to.path == '/'){
  //     next({
  //       path: '/index'
  //     })
  //   }else{
  //     next();
  //   }
  // }
})
router.afterEach((to, from) => {
  // console.log(to)
  // store.commit('SET_ENTRY_URL','');
    setTimeout(() => {
      store.dispatch('setEntryUrl','');
    },1*1000)
})
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router


// WEBPACK FOOTER //
// ./src/permission.js